
import Stream from "@/components/livestream/Stream"
import Modal from "@/components/base/modal/Modal"
import RequestLogin from "@/components/user/RequestLogin"
import LivestreamTabs from "@/components/livestream/LivestreamTabs"
import LivestreamChat from "@/components/livestream/LivestreamChat"
import LivestreamBusinesses from "@/components/livestream/LivestreamBusinesses"

import defaultMeta from "@/mixins/defaultMeta"
import breadcrumb from "@/mixins/breadcrumb"
import { mapGetters, mapActions } from "vuex"
import { mdiChevronLeft, mdiEye } from "@mdi/js"
import { COOKIE_PREVIOUS_SEARCH_ROUTE } from "@/enums/cookies"

export default {
    components: {
        LivestreamBusinesses,
        LivestreamChat,
        LivestreamTabs,
        Stream,
        Modal,
        RequestLogin,
        Login: () => import("@/components/auth/Login"),
    },
    mixins: [breadcrumb, defaultMeta],
    layout: "fullscreen",
    watchQuery: true,
    data: () => {
        return {
            mdiEye,
            mdiChevronLeft,
        }
    },
    computed: {
        ...mapGetters("livestream", [
            "viewers",
            "lowerBound",
            "isLive",
            "hasAppearances",
            "shouldLoginToSendMessages",
        ]),
        ...mapGetters("routing", ["previousRoute"]),
    },
    mounted() {
        this.cityName = this.$route.params.cityName
        this.$store.dispatch(
            "livestream/initialize",
            this.$route.params.livestream
        )
        this.$store.commit("livestream/SET_MUTED", false)
        this.closeWindow(false)
    },
    destroyed() {
        this.closeWindow(true)
    },
    methods: {
        ...mapActions("livestream", ["closeWindow"]),
        routeBack() {
            if (this.$route.params.livestream == 9) {
                this.$router.push("/landesversammlung-bsv")
                return
            }
            if (
                this.previousRoute &&
                this.previousRoute.path !== "/livestream/suche"
            ) {
                this.$store.dispatch("routing/back")
            } else {
                if (this.$cookies.get(COOKIE_PREVIOUS_SEARCH_ROUTE)) {
                    const route = this.$cookies.get(
                        COOKIE_PREVIOUS_SEARCH_ROUTE
                    )
                    this.$router.push(route)
                } else {
                    this.$router.push("/")
                }
            }
        },
        closeLoginToSendMessageModal() {
            this.$store.commit(
                "livestream/SET_SHOULD_LOGIN_TO_SEND_MESSAGE",
                false
            )
        },
    },
    head() {
        return {
            title: "Firmen im Livestream",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        "Erlebe die besten Arbeitgeber deiner Region im Livestream und finde deine Ausbildung.",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content:
                        "Erlebe die besten Firmen/Arbeitgeber deiner Region LIVE.",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        "Erlebe die besten Arbeitgeber deiner Region im Livestream und finde deine Ausbildung.",
                },
            ],
            __dangerouslyDisableSanitizers: ["script"],
            script: [
                {
                    innerHTML:
                        this.location && JSON.stringify(this.getBreadcrumb()),
                    type: "application/ld+json",
                },
            ],
        }
    },
}
